import { Divider, Fade, Paper, Popper } from "@mui/material";
import React from "react";
import { Typography } from "@platform/design-system";

const viewportPaddingPx = 64;
const minCardWidthPx = 360;
const maxCardWidthPx = 700;

export interface FieldCommentCardProps {
  comment: string;
  anchorEl?: HTMLElement | null;
  open?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const FieldCommentCard: React.FC<FieldCommentCardProps> = ({
  comment,
  anchorEl,
  open = false,
  onMouseEnter,
  onMouseLeave,
}): React.JSX.Element => (
  <Popper
    open={open}
    anchorEl={anchorEl}
    placement="top"
    transition
    style={{ zIndex: 1300 }}
    modifiers={[
      { name: "preventOverflow", options: { padding: viewportPaddingPx } },
    ]}
  >
    {({ TransitionProps }) => (
      <Fade {...TransitionProps} timeout={150}>
        <Paper
          elevation={4}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          sx={{
            width: "max-content",
            minWidth: `min(${minCardWidthPx}px, calc(100vw - ${viewportPaddingPx * 2}px))`,
            maxWidth: `min(${maxCardWidthPx}px, calc(100vw - ${viewportPaddingPx * 2}px))`,
            mt: 1,
            p: 2,
          }}
        >
          <Typography>
            <strong>Comment</strong>
          </Typography>
          <Divider sx={{ my: 1 }} />
          <Typography
            variant="body-medium"
            sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}
          >
            {comment}
          </Typography>
        </Paper>
      </Fade>
    )}
  </Popper>
);
